<template>
    <div :class="['onboarding-container onboarding-input row visible-on', type === 'file' ? 'col-sm-7 col-sm-offset-3 col-md-8 col-lg-4 col-md-offset-1 col-lg-offset-4' : 'col-md-8 col-lg-5 col-md-offset-1 col-lg-offset-3']">
        <div ref="form-label" :class="['col-xs-11 form-label', type === 'file' ? 'file-label col-sm-5 col-md-10 col-lg-10' : 'col-sm-5 col-md-5 col-lg-4', fixStyle]">
            <span class="tooltip-icon iconfont iconquestion-mark" v-if="hasPcTooltip" @click="toggleTooltip()"></span>
            <span class="label-text">{{ label }}</span>
            <span class="tooltip-icon iconfont iconquestion-mark" v-if="hasMobileTooltip" @click="toggleTooltip()"></span>
        </div>
        <input v-if="type != 'file'" :type="type ? type : 'text'" ref='input' :value="internalValue" v-on:input="changeValue($event)" :class="['form-component col-xs-12 col-sm-5 col-md-7 col-lg-8', isDisabled ? 'disable' : '', (patternPass && !errorMessage && !internalErrorMessage) ? '' : 'error-border']" :placeholder="placeholder" :maxlength="maxlength">
        <div v-else class="file-div col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="first-row"><div class="file-display-div form-component"><span>{{ selectedFileName || fileName }}</span></div><button class="form-component browser-btn" @click="selectFile">Browser</button></div>
            <div class="second-row">
              <button
                ref="upload-btn"
                :class="['upload-btn form-component main-background-style custom-bg-color', selectedFileName ? '' : 'button-disabled']"
                @click="handleUploadFile">
                {{ $t('onboarding.nestle.upload') }}
                <i v-if="inUploadProgress" class="el-icon-loading upload-icon"></i>
                <img v-else class="upload-icon" :src="uploadIcon" alt="">
              </button>
              <div :class="['message form-component']">
                <span>{{ fileTypeErrorMsg || uploadProgressMessage }}</span>
              </div>
            </div>
            <input ref="file-input" type="file" @change="changeFile($event)" :accept="accept">
        </div>
        <transition name="fade">
            <div class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 tooltip-text" v-if="(toolTipMessage && showTooltip) || !this.patternPass">{{ this.toolTipMessage }}</div>
        </transition>
        <div v-if="notice" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 notice-text">{{ this.notice }}</div>
        <div v-if="errorMessage || internalErrorMessage" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 error-text">{{ this.internalErrorMessage || this.errorMessage }}</div>
    </div>
</template>
<script>
import { onboardingMixin } from './mixin.js'
import { deviceType } from '@/utils/common'

export default {
  // @label: the field title.
  // @isEditable: whether this field can be edited.
  // @notice: the notice message displayed on the bottom of the field.
  // @placeholder: when value is empty, the placeholder text displayed on the field.
  // @isRequired: whether this field can be empty.
  // @tooltip: the tip icon that show related tip message.
  // @regex: the Regex pattern that is used for validate.(when using regex, the tooltip must be set!)
  // @errorMessage: show the special requirement message. e.g.: password and repassword not same.
  // @password: only is used to compare password with the re-enter password on re-enter password component.
  // @type: the input type, such as 'text'(default)/'file'/'password'/...
  // @upload: the upload event function when click the upload button only for file type.
  // @fileType: the fileTypes that are allowed to be uploaded. e.g. '.jpg,.png.mp4'.
  // @accept: the standard accept property of native input component.(cannot be used with @fileType together)
  // @fileName: the fileName displayed on the file input field.
  // @uploadProgressMessage: the message that show the upload is sucessful or fail.
  // @questionId: the questionId will be used for upload component.

  mixins: [onboardingMixin],
  props: ['label', 'isEditable', 'notice', 'placeholder', 'value', 'isRequired', 'regex', 'tooltip', 'type', 'upload', 'fileType', 'fileName', 'uploadProgressMessage', 'accept', 'errorMessage', 'password', 'questionId', 'maxlength'],
  data () {
    return {
      isDisabled: this.isEditable === 'false',
      tooltipIcon: require('@/assets/image/onboarding/common/tooltip.png'),
      uploadIcon: require('@/assets/image/onboarding/common/upload.png'),
      hasMobileTooltip: this.tooltip && deviceType.isMobile,
      hasPcTooltip: this.tooltip && !deviceType.isMobile,
      internalValue: '',
      showTooltip: false,
      patternPass: true,
      tooltipStyle: '',
      tooltipStylePc: '',
      selectedFileName: '',
      fileTypeErrorMsg: '',
      internalErrorMessage: '',
      regexValue: this.regex,
      toolTipMessage: this.tooltip,
      inUploadProgress: false
    }
  },
  created () {
    if (this.type !== 'file') {
      this.internalValue = this.value
    }
  },
  mounted () {
    if (this.isDisabled) {
      this.$set(this.$refs.input, 'disabled', 'disabled')
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    },
    '$i18n.locale' (val) {
      this.validate()
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired)) {
        if (this.type !== 'file') {
          if (!this.internalValue) {
            this.internalErrorMessage = this.isRequiredMessage
            return false
          }
        } else {
          if (!this.value) {
            this.internalErrorMessage = this.$t('onboarding.nestle.error.fileNotUpload')
            return false
          }
        }
      }

      if (this.$refs['file-input'] && this.$refs['file-input'].files && this.$refs['file-input'].files[0] && this.$refs['file-input'].files[0].size > 4194304) {
        this.internalErrorMessage = this.$t('onboarding.nestle.error.fileSizeError')
        return false
      }

      if (this.password && this.type !== 'file') {
        if (this.internalValue !== this.password) {
          this.internalErrorMessage = this.$t('onboarding.nestle.error.passwordNotSame')
          return false
        }
      }

      if (this.regexValue) {
        const pattern = new RegExp(this.regexValue)
        if (!pattern.test(this.internalValue)) {
          this.patternPass = false
          this.showTooltip = true
          return false
        }
      }
      this.patternPass = true
      this.showTooltip = false
      this.internalErrorMessage = ''
      return true
    },
    toggleTooltip () {
      if (!this.patternPass) {
        return
      }
      this.showTooltip = !this.showTooltip
    },
    selectFile () {
      this.$refs['file-input'].click()
    },
    changeValue (event) {
      this.internalValue = event.target.value
      if (this.fieldIsRequired(this.isRequired)) {
        this.internalErrorMessage = this.internalValue ? '' : this.isRequiredMessage
      }
      if (this.password) {
        if (event.target.value !== this.password) {
          this.internalErrorMessage = this.$t('onboarding.nestle.error.passwordNotSame')
          return
        } else {
          this.internalErrorMessage = ''
        }
      }
      if (this.regexValue) {
        const pattern = new RegExp(this.regexValue)
        if (!pattern.test(event.target.value)) {
          this.patternPass = false
          this.showTooltip = true
          return
        }
      }

      this.patternPass = true
      this.showTooltip = false
    },
    changeFile (event) {
      if (!event.target.files) {
        return
      }
      const file = event.target.files[0]
      if (!file) {
        return
      }
      this.selectedFileName = file.name
      const fileTypeFromName = file.name.includes('.') && file.name.replace(/.*\.(.*)$/, '$1').toLowerCase()
      if (this.fileType && !this.accept) {
        if (!fileTypeFromName || !this.fileType.includes(fileTypeFromName)) {
          this.$set(this.$refs['upload-btn'], 'disabled', 'disabled')
          this.fileTypeErrorMsg = '文件格式错误！仅支持: '.concat(this.fileType.toString())
          return
        }
      }
      if (file.size > 4194304) {
        this.$set(this.$refs['upload-btn'], 'disabled', 'disabled')
        this.internalErrorMessage = 'This file exceeds the maximum size limit of 4 MB. Please upload a smaller file.'
        return
      } else {
        this.internalErrorMessage = ''
      }
      this.$set(this.$refs['upload-btn'], 'disabled', false)
      this.fileTypeErrorMsg = ''
      this.$emit('input', file)
    },
    handleUploadFile () {
      if (this.inUploadProgress) {
        return
      }
      this.upload(this.questionId, this)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '~@/assets/iconfont/iconfont.css';
.onboarding-input {
    margin-bottom: 1.2rem;
    span {
        display: inline-block;
    }
    input {
        border: solid 1px gray;
        border-radius: 0; //去除iOS浏览器中显示圆角
        -webkit-appearance : none ;
    }
    .disable {
        background-color: rgb(201, 201, 201);
        color: black;
        opacity: 1;
    }
    .error-border {
        border: solid 1px red;
    }
    .tooltip-icon {
        font-size: x-large;
        color: gray;
    }
    .tooltip-text {
        margin-top: 5px;
        font-size: small;
        padding: 0;
    }
    .file-label {
        text-align: left;
        justify-content: flex-start;
    }
    .file-div {
        margin-top: 10px;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        user-select: none;
        .first-row {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .file-display-div {
                padding: 10px 20px;
                border-top: solid 1px gray;
                border-left: solid 1px gray;
                border-bottom: solid 1px gray;
                display: inline-flex;
                background-color: lightgray;
                justify-content: flex-start;
                align-items: center;
                width: 70%;
                span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .browser-btn {
                width: 30%;
                border-top: solid 1px gray;
                border-right: solid 1px gray;
                border-bottom: solid 1px gray;
                background-color: white;
            }
        }
        .second-row {
            margin-top: 10px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            button {
                width: 30%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 20px;
                color: white;
                border-radius: none;
                border: none;
            }
            .button-disabled {
                cursor: auto;
                background-color: gray;
            }
            .button-disabled {
                cursor: auto;
                background-color: gray;
            }
            .upload-icon {
                margin-left: 10px;
                width: 15px;
                height: 15px;
            }
            .message {
                padding: 10px;
                width: 70%;
            }
            .error-message {
                @extend .message;
                color: red;
            }
            .success-message {
                @extend .message;
                color: green;
            }
        }
        input {
            display: none;
        }
    }
}
</style>
